<template>
  <div>
    <b-alert :show="errors.any()" variant="danger" class="mb-2 py-2 px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <widget
      :type="widget.type"
      :title="widget.title"
      :subtitle="widget.subtitle"
      :url="widget.url"
      :availability="widget.availability"
      :viewData="widget.viewData"
      :view="widget.view"
      @update:type="widget.type = $event"
      @update:title="widget.title = $event"
      @update:subtitle="widget.subtitle = $event"
      @update:url="widget.url = $event"
      @update:availability="widget.availability = $event"
      @update:viewData="widget.viewData = $event"
      @update:view="widget.view = $event"
    >

      <uploader
        :label="$t('shared.image')"
        v-model="widget.image"
        accept=".png,.jpg,.jpeg,.gif,.svg"
        :name="$t('shared.image')"
        class="mb-2"
      />

      <h6 class="mt-3 mb-2">{{$t('widgetAreas.images')}}:</h6>

      <template v-if="widget.items && widget.items.length">
        <draggable
          :list="widget.items"
          v-bind="getSortableOptions()"
          @change="setSortOrders"
        >
          <item v-for="item in widget.items" :key="item.id" :item="item" @remove="removeItem"/>
        </draggable>
      </template>

      <b-btn size="sm" class="mt-2" variant="success" @click="addItem">
        <font-awesome-icon icon="plus" fixed-width class="align-middle"/>
      </b-btn>
    </widget>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

import Item from './Item'
import EditorMixin from '../EditorMixin'
import Widget from '../../Widget'
import Uploader from '@/components/shared/Uploader'

export default {
  name: 'ItemsWidget',
  mixins: [EditorMixin],
  components: {
    draggable,
    Uploader,
    Widget,
    Item
  },
  watch: {
    widget: {
      handler (val) {
        this.emitTitle(val)
      },
      deep: true
    }
  },
  mounted () {
    this.emitTitle(this.widget)
  },
  methods: {
    addItem () {
      let item = {
        id: -String(Math.floor(Math.random() * 99999999)),
        title: null,
        description: null,
        image: null,
        url: null,
        viewData: null,
        sortOrder: 1000
      }
      this.widget.items.push(item)
    },
    removeItem (item) {
      if (confirm(this.$t('shared.areYouSureToRemoveThisItem'))) {
        this.widget.items = this.widget.items.filter(l => l.id !== item.id)
      }
    },
    getSortableOptions () {
      return {
        handle: '.item-handle',
        dragClass: 'item-drag',
        group: 'items',
        animation: 200
      }
    },
    setSortOrders () {
      this.widget.items.forEach((i, index) => i.sortOrder = index)
    },
    emitTitle (widget) {
      let title = []

      if (widget.title)
        title.push(widget.title)

      else if (widget.view)
        title.push(widget.view)

      if (widget.items && widget.items.length)
        title.push(widget.items.length + 'items')

      this.$emit('setTitle', title.join(' - '))
    }
  }
}
</script>
